<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (!!userScenario) {
<div class="component-container">
  <div class="add-margin">
    <div class="list-container">
      <app-tasks [taskList]="taskList" [resultList]="results" [scenarioId]="userScenario.id" [isEditable]="true"
        [isExecutable]="true" (taskListChanged)="refreshTaskList()"
        (deleteTaskRequested)="deleteTask($event)"></app-tasks>
    </div>
  </div>
</div>
}
